import { getColorKeyEntries } from 'Content/CityDatas/sat_images/color_key_entries'
import { ColorKey } from 'components/ColorKey'
import { ReactNode } from 'react'
import styled from 'styled-components'

const ImageCollection = ({
  title,
  text,
  entries,
  showColorKey = false,
  labels,
  colorMode,
  lang,
}: {
  title?: string | ReactNode
  text?: string | ReactNode
  entries?: {
    label: string
    image: string
    subline?: string
    image_dm?: string
  }[]
  showColorKey?: boolean
  labels: any

  colorMode: 'light' | 'dark' | undefined
  lang: 'de' | 'fr'
}) => {
  return (
    <ImageCollectionContainer className='imccontainer'>
      {title && (
        <Title>
          <span>{title}</span>
        </Title>
      )}
      {text && <Text>{text}</Text>}
      {showColorKey && (
        <ColorKey
          entries={getColorKeyEntries(colorMode, lang) as any}
        />
      )}
      <Images>
        {entries &&
          entries.map((entry,i) => {
            return (
              <ImageCol key={"image_"+i}>
                <Label>{entry.label}</Label>
                {entry.subline && <Subline>{entry.subline}</Subline>}
                <Image
                  src={
                    colorMode === 'dark' && entry.image_dm
                      ? entry.image_dm
                      : entry.image
                  }
                />
              </ImageCol>
            )
          })}
      </Images>
    </ImageCollectionContainer>
  )
}
const ImageCollectionContainer = styled.div`
  margin-bottom: 60px;
  font-family: var(--font-sans-serif);
  @media screen and (max-width: 711px) {
    margin-bottom: 8px;
  }
`
const Title = styled.div`
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-bottom: 30px;
  line-height: 1.3em;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  font-family: var(--font-serif);

  span {
    flex: 0 0 100%;
  }
  div {
    font-weight: 300;
  }
  @media screen and (max-width: 711px) {
    text-align: left;
    margin-bottom: 30px;
    font-size: 18px;
    justify-content: flex-start;
  }
`
const Images = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  @media screen and (max-width: 711px) {
    gap: 8px;
  }
`

const ImageCol = styled.div`
  position: relative;
  flex: 0 0 calc(50% - 10px);
  line-height: 0;
  @media screen and (max-width: 711px) {
    flex: 0 0 calc(100%);
    margin-bottom: 0px;
  }
`
const Image = styled.img`
  max-width: 100%;
`

const Text = styled.div`
  margin-top: 15px;
  font-family: var(--font-serif);
  margin-bottom: 15px;
  /* font-size: 2px; */

  @media screen and (max-width: 711px) {
    text-align: left;
    margin-bottom: 15px;
  }
`

const Label = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 2px 10px 2px 10px;

  background-color: var(--text-color);
  color: var(--site-background);
  text-align: center;
  line-height: 2em;
  margin-bottom: 10px;
  font-size: 15px;
  @media screen and (max-width: 711px) {
    font-size: 13px;
  }
`
const Subline = styled.div`
  position: absolute;
  top: 30px;
  left: 0;
  padding: 2px 10px 2px 0;
  background-color: var(--site-background);
  text-align: center;
  line-height: 2em;
  margin-bottom: 10px;
  font-size: 15px;
`
export default ImageCollection
